import axios from 'axios'
import store from './../store';

export default class KycService {

    async initCheck(documents) {
        const res = await axios({
            method: 'post',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: documents
        });
        return res.data
    }

    async getSelf() {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/me',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        return res.data
    }

    async getApplications(status) { 
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc',
            headers: {
                authorization: store.state.currentUser.token
            },
            params: {
                status: status
            }
        });

        const data = res.data;
        data.map(el => {
            const name = el.name;
            const surname = el.surname;
            el.name = `${name} ${surname}`;
        });

        return res.data
    }

    async fetchDocuments(kyc_id) {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/documents/' + kyc_id + '?timestamp=' + Date.now(),
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        return res.data
    }

    async approveApplication(kyc_id, message) {
        const res = await axios({
            method: 'put',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/approve',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: {
                id: kyc_id,
                message: message
            }
        });
        return res.data
    }

    async approveUser(user_id) {
        const res = await axios({
            method: 'post',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/approve_user',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: {
                id: user_id
            }
        });
        return res.data
    }

    async denyApplication(kyc_id, message) {
        const res = await axios({
            method: 'put',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/deny',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: {
                id: kyc_id,
                message: message
            }
        });
        return res.data
    }

    async denyUser(user_id) {
        const res = await axios({
            method: 'post',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/deny_user',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: {
                id: user_id
            }
        });
        return res.data
    }

    async numberPending() {
        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/numberpending',
            headers: {
                authorization: store.state.currentUser.token
            }
        });
        return res.data.num
    }

    async rotateImage(id, direction) {
        const res = await axios({
            method: 'post',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc/rotateimage',
            headers: {
                authorization: store.state.currentUser.token
            },
            data: {
                id: id,
                direction: direction
            }
        });
        return res.data.num
    }
}